import { render, staticRenderFns } from "./NotificationDropdown.vue?vue&type=template&id=7879ce7b&"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js&"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7879ce7b')) {
      api.createRecord('7879ce7b', component.options)
    } else {
      api.reload('7879ce7b', component.options)
    }
    module.hot.accept("./NotificationDropdown.vue?vue&type=template&id=7879ce7b&", function () {
      api.rerender('7879ce7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/components/NotificationDropdown.vue"
export default component.exports